import React, { useState, useEffect } from "react";
import {
	IonToolbar,
	IonGrid,
	IonRow,
	IonContent,
	IonButton,
	IonButtons,
	IonHeader,
	IonMenuButton,
	IonPage,
	IonTitle,
	IonSearchbar
} from "@ionic/react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NoDataFound from "../../components/NoDataFound";
import PlusIcon from "../../components/PlusIcon";
import PropertyListItem from "../../components/PropertyListItem";
import useStore from "../../store/store";

const Properties: React.FC = () => {
	const { t } = useTranslation();
	const [data, setData] = useState<any[]>([]);
	const history = useHistory();
	const [keyword, setKeyword] = useState<string>("");
	const { token } = useStore((state: any) => state);

	useEffect(() => {
		getData();
	}, [keyword]);

	const getData = () => {
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/properties/all`,
				{
					keyword: keyword
				},
				{ headers: { rentapp_auth: token } }
			)
			.then(res => setData(res.data))
			.catch(err => console.log(err));
	};

	return (
		<IonPage>
			<IonHeader>
				<IonToolbar>
					<IonButtons slot="start">
						<IonMenuButton />
					</IonButtons>
					<IonButtons slot="end">
						<IonButton
							onClick={(e: any) => {
								e.preventDefault();
								history.push("/properties/new");
							}}
						>
							<PlusIcon />
						</IonButton>
					</IonButtons>
					<IonTitle>{t("properties")}</IonTitle>
				</IonToolbar>
			</IonHeader>

			<IonContent fullscreen>
				<IonHeader collapse="condense">
					<IonToolbar>
						<IonTitle size="large">{t("properties")}</IonTitle>
					</IonToolbar>
				</IonHeader>
				<IonGrid>
					<IonRow>
						<IonSearchbar
							debounce={500}
							showClearButton="focus"
							onIonChange={e => setKeyword(e.target.value || "")}
						></IonSearchbar>
					</IonRow>
					<IonRow>
						{data.length === 0 && <NoDataFound />}
						{data.map((elem, index) => (
							<PropertyListItem
								elem={elem}
								key={index}
								reload={getData}
							/>
						))}
					</IonRow>
				</IonGrid>
			</IonContent>
		</IonPage>
	);
};

export default Properties;
